import { useDispatch, useSelector } from 'react-redux';
import { getLanguageName } from 'util/llmTranslation';
import { selectTicketLanguage } from 'extractFromState';
import { selectShowTranslated } from 'selectors/uiMessages';
import { setShowTranslated } from 'actions/uiMessagesActions';
import { DEFAULT_CONVERSATION_LANGUAGE_CODE } from 'constants/llmTranslation';
import { Root, Label, Radio } from './LanguageSwitch.styles';
/**
 * UI component that allows users to toggle between showing original and translated messages.
 * It uses a state flag to keep track of the user's reference (state.ui.messages.showTranslated).
 */
export default function LanguageSwitch() {
  const dispatch = useDispatch();
  const ticketLanguage = useSelector(selectTicketLanguage);
  const showTranslatedMessages = useSelector(selectShowTranslated);

  const handleChange = (ev) => {
    const show = ev.target.value !== DEFAULT_CONVERSATION_LANGUAGE_CODE;
    dispatch(setShowTranslated(show));
  };

  return (
    <Root role="radiogroup">
      <Label>
        <Radio
          type="radio"
          name="language_switch"
          value={ticketLanguage}
          checked={showTranslatedMessages}
          onChange={handleChange}
        />
        {getLanguageName(ticketLanguage)} (Original)
      </Label>
      <Label>
        <Radio
          type="radio"
          name="language_switch"
          value={'en'}
          checked={!showTranslatedMessages}
          onChange={handleChange}
        />
        English
      </Label>
    </Root>
  );
}
